import Vue from "vue";
import Component from "vue-class-component";
import { FormValues, Dictionary, FormFields, ListFields } from "@/types";
import { paymentSystems, filteredPaymentSystems } from "./config";
import { cloneDeep } from "lodash-es";
import { $t } from "@/lib/helpers/i18nHelper";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";

@Component({ name: "PaymentSystemMixin" })
export default class PaymentSystemMixin extends Vue {
  public getDetails(values: FormValues): Dictionary<any> {
    const details = { ...values };
    delete details.active;
    delete details.type;
    return details;
  }

  get systemList(): ListFields {
    return filteredPaymentSystems.reduce((out, system) => {
      out.push({
        value: system.type,
        text: system.name,
      });
      return out;
    }, [] as ListFields);
  }

  public getPaymentSystemInfo(type: string): Dictionary<any> {
    const info = paymentSystems.find(system => system.type === type) || paymentSystems[0];
    return cloneDeep(info);
  }

  public getCurrenciesValue(check: boolean, currencyCode: string, values: string[]): string[] {
    const newValues = values.filter(i => i !== currencyCode);
    if (check) return [currencyCode, ...newValues];
    return newValues;
  }

  public fieldsBuilder(
    type: string,
    activeValue: boolean,
    statusIndex: number = 1,
    currencies: Currency[] = []
  ): FormFields {
    const info = this.getPaymentSystemInfo(type);
    const fields: FormFields = [...info.fields];
    fields.splice(statusIndex, 0, {
      title: $t("Status"),
      name: "active",
      type: "select",
      value: activeValue,
      list: [
        {
          text: $t("Active"),
          value: true,
        },
        {
          text: $t("Inactive"),
          value: false,
        },
      ],
    });
    fields.push({
      name: "currencies",
      title: $t("Available currencies"),
      flexClass: "col-12",
      type: "checkbox-group",
      value: [],
      list: currencies.reduce((out, item) => {
        out.push({ value: item.name, text: item.name });
        return out;
      }, [] as ListFields),
    });
    return fields;
  }
}
